<script setup>
import { ref } from 'vue';

import AppMenuItem from './AppMenuItem.vue';

const model = ref([
    {
        label: 'Home',
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
    },
    {
        label: 'CERTH',
        items: [
            { label: 'Whitebox (WBX-FL)', icon: 'pi pi-fw pi-box', to: '/certh/whitebox' },
            { label: 'Blackbox (BBX-noFL)', icon: 'pi pi-fw pi-box', to: '/certh/blackbox' },
            { label: 'Content-Based Similarity Search (CBS)', icon: 'pi pi-fw pi-images', to: '/certh/cbs' },
            { label: 'Image Manipulation (ImMan)', icon: 'pi pi-fw pi-image', to: '/certh/im-man' },
            { label: 'Machine Unlearning (LOTUS)', icon: 'pi pi-fw pi-file-edit', to: '/certh/lotus' }
        ]
    },
    {
        label: 'Engineering',
        items: [{ label: 'GAIDE', icon: 'pi pi-fw pi-cog', to: '/eng/gaide' }]
    },
    {
        label: 'Siemens AG',
        items: [
            { label: 'XAI4RecSys – Multi-Modal', icon: 'pi pi-fw pi-database', to: '/siemens/multi-modal' },
            { label: 'XAI4RecSys – RRIM', icon: 'pi pi-fw pi-database', to: '/siemens/rec-sys' }
        ]
    },
    {
        label: 'Athens Technology Center',
        items: [
            { label: 'Hate Speech Detection (HSD)', icon: 'pi pi-fw pi-comments', to: '/atc/hate-speech' },
            { label: 'Sentiment Analysis (SENTAN)', icon: 'pi pi-fw pi-megaphone', to: '/atc/sentiment-analysis' }
        ]
    },
    {
        label: 'Vicomtech',
        items: [{ label: 'EvaXplanify', icon: 'pi pi-fw pi-chart-bar', to: '/vicomtech' }]
    }
]);
</script>

<template>
    <ul class="layout-menu">
        <template v-for="(item, i) in model" :key="item">
            <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
            <li v-if="item.separator" class="menu-separator"></li>
        </template>
    </ul>
</template>
